// extracted by mini-css-extract-plugin
export var container = "_s3-0";
export var dotAnimation = "_s3-2";
export var dotsLoading = "_s3-1";